import { render } from "./Index.vue?vue&type=template&id=07a03002&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=07a03002&lang=scss&scoped=true"
import "./Index.vue?vue&type=style&index=1&id=07a03002&lang=css"

import exportComponent from "/Users/fanhaipeng/code/giga-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07a03002"]])

export default __exports__